import React, { Component } from 'react';
import Slider from 'react-slick';
import { Form, Icon, Input, Button, Checkbox } from 'antd';
import axios from 'axios';
const FormItem = Form.Item;
const TextArea = Input.TextArea;
class ContactForm extends Component {
  handleSubmit = (e) => {
    const form = this.props.form;

    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        axios({
          method:'post',
          url:'https://formspree.io/f/xzbokwpl',
          data: values
        })
        .then(function(response) {
            alert ("Thanks for your submit! We will contact you back"); //console.log(response)
            form.resetFields();
        });
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="contact-form">
        <div className="content-wrap">
          <h2 className='title'>CONTACT</h2>
          <p className="content margin-center">Provide your request with project and timing details</p>

          <Form onSubmit={this.handleSubmit}>
            <FormItem>
              <label>Email</label>
              {getFieldDecorator('Email', {
                rules: [{ required: true, message: 'Please provide your email' }],
              })(
                <Input type="email" />
              )}
            </FormItem>
            <FormItem>
              <label>Subject</label>
              {getFieldDecorator('Subject', {
                rules: [{ required: true, message: 'Please provide the subject' }],
              })(
                <Input type="text" />
              )}
            </FormItem>
            <FormItem>
              <label>Messenger</label>
              {getFieldDecorator('Messenger', {
                rules: [{ required: true, message: 'Please paste your message' }],
              })(
                <TextArea></TextArea>
              )}
            </FormItem>
            <FormItem>
              <Button type="primary" htmlType="submit" className="submitForm">
                SUBMIT
              </Button>
            </FormItem>
          </Form>
        </div>
      </div>
    );
  }
}

const WrappedContactForm = Form.create()(ContactForm);
export default WrappedContactForm;


// WEBPACK FOOTER //
// ./src/Landing/contactForm.js